import React, { useState } from "react"
import { TextField, Button } from ".."
import useLocalStorage from '../../hooks/useLocalStorage'
import { makeStyles } from "@material-ui/core/styles"
import auth from '../../constants/authConsts'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    height: '100%',
    padding: theme.spacing(4),
    margin: '0 auto',
    justifyContent: 'center',
    maxWidth: theme.spacing(100)
  },
  divStyles: {
    backgroundColor: theme.palette.white.main,
  },
}))


export default ({ children }) => {
  const classes = useStyles()
  const [authenticated, setAuthenticated] = useLocalStorage('avcn_auth', false)
  const [user, setUser] = useState('')
  const [pass, setPass] = useState('')
  const handleChange = setter => value => {
    setter(value)
  }

  const authenticate = () => {
    if (user === auth.user && pass === auth.pass) {
      setAuthenticated(true)
    }
  }
  return authenticated
  ? (
    <div className={classes.divStyles}>
      {children}
    </div>
  )
  : (
    <div className={classes.root}>
      <TextField label={'Username'} initialValue={user} onChange={handleChange(setUser)}/>
      <TextField label={'Password'} type={'password'} initialValue={pass} onChange={handleChange(setPass)}/>
      <Button onClick={() => {authenticate()}} color={'green'}>Authenticate</Button>
    </div>
  )
}
